<section class="mobilephone-gtin-type">
  <div class="options-container">
    <app-ice-input-field
      errorText="EAN/GTIN-nummer er ikke gyldig"
      inputWidth="medium"
      label="EAN/GTIN"
      ngDefaultControl
      textTestId="gtin-input"
      [errorOnTouchedOnly]="true"
      [focusOnLoad]="true"
      [formControlName]="MobilePhoneFormControls.Gtin"
      (keydown.enter)="focusImeiField($event)"
    />
    <div class="info-text">
      <mat-icon [svgIcon]="IconNames.ice_info" />
      <button data-testid="open-gtin-info-dialog-button" (click)="openDialogService.openGtinInfoDialog()">
        Hvordan finne EAN/GTIN?
      </button>
    </div>

    <app-ice-input-field
      inputWidth="medium"
      label="IMEI - Scan eller tast inn manuelt"
      ngDefaultControl
      textTestId="imei-input"
      [errorText]="getImeiErrorText(imeiControl?.errors)"
      [forId]="imeiElementId"
      [formControlName]="MobilePhoneFormControls.Imei"
      [maxLength]="16"
      [showErrorOnLoad]="!!imeiControl?.value"
      (keydown.enter)="$event.preventDefault()"
    />
    <div class="info-text">
      <mat-icon [svgIcon]="IconNames.ice_info" />
      <button data-testid="open-imei-info-dialog-button" (click)="openDialogService.openImeiInfoDialog()">
        Hvordan finne IMEI?
      </button>
    </div>
  </div>
</section>
